/**
 * Génère les items de breadcrumb pour une route admin donnée.
 * Centralisé pour que AdminPageShell ET les pages qui consomment
 * AdminAppShell directement (Dashboard, ArticlesList, ContactsList,
 * ProfessionalList, StageList) partagent la même source de vérité.
 */

const BREADCRUMB_NODES = {
  '/dashboard':                       { label: 'Tableau de bord' },
  '/dashboard/articles':              { label: 'Articles',           parent: '/dashboard' },
  '/dashboard/articles/new':          { label: 'Nouvel article',     parent: '/dashboard/articles' },
  '/dashboard/articles/:id':          { label: 'Modifier',           parent: '/dashboard/articles' },
  '/dashboard/articles/:id/view':     { label: 'Aperçu',             parent: '/dashboard/articles' },

  '/dashboard/analytics':             { label: 'Analytics',          parent: '/dashboard' },

  '/dashboard/projects':              { label: 'Projets',            parent: '/dashboard' },
  '/dashboard/projects/new':          { label: 'Nouveau projet',     parent: '/dashboard/projects' },
  '/dashboard/projects/:id':          { label: 'Modifier',           parent: '/dashboard/projects' },

  '/dashboard/stages':                { label: 'Stages',             parent: '/dashboard' },
  '/dashboard/stages/new':            { label: 'Nouveau stage',      parent: '/dashboard/stages' },
  '/dashboard/stages/:id':            { label: 'Modifier',           parent: '/dashboard/stages' },

  '/dashboard/professionals':         { label: 'Professionnels',     parent: '/dashboard' },
  '/dashboard/professionals/new':     { label: 'Nouveau',            parent: '/dashboard/professionals' },
  '/dashboard/professionals/:id':     { label: 'Modifier',           parent: '/dashboard/professionals' },

  '/dashboard/newsletter':            { label: 'Newsletter',         parent: '/dashboard' },
  '/dashboard/newsletter/:id':        { label: 'Abonné',             parent: '/dashboard/newsletter' },

  '/dashboard/contacts':              { label: 'Contacts',           parent: '/dashboard' },
  '/dashboard/contacts/settings':     { label: 'Réglages',           parent: '/dashboard/contacts' },
  '/dashboard/contacts/:id':          { label: 'Message',            parent: '/dashboard/contacts' },

  '/dashboard/users':                 { label: 'Utilisateurs',       parent: '/dashboard' },
  '/dashboard/users/new':             { label: 'Nouvel utilisateur', parent: '/dashboard/users' },
  '/dashboard/users/:id':             { label: 'Modifier',           parent: '/dashboard/users' },

  '/dashboard/profile':               { label: 'Mon profil',         parent: '/dashboard' },
  '/dashboard/cvs':                   { label: 'CV',                 parent: '/dashboard' },
};

function matchPattern(pattern, actual) {
  const pp = pattern.split('/');
  const ap = actual.split('/');
  if (pp.length !== ap.length) return false;
  for (let i = 0; i < pp.length; i += 1) {
    if (pp[i].startsWith(':')) continue;
    if (pp[i] !== ap[i]) return false;
  }
  return true;
}

function findNodeKey(pathname) {
  if (BREADCRUMB_NODES[pathname]) return pathname;
  // /dashboard/contacts/settings doit matcher AVANT /dashboard/contacts/:id
  // → trier les patterns littéraux en premier
  const keys = Object.keys(BREADCRUMB_NODES).sort((a, b) => {
    const aHas = a.includes(':') ? 1 : 0;
    const bHas = b.includes(':') ? 1 : 0;
    return aHas - bHas;
  });
  return keys.find((p) => matchPattern(p, pathname)) || null;
}

function reifyHref(pattern, actualPath) {
  const pp = pattern.split('/');
  const ap = actualPath.split('/');
  return pp.map((seg, i) => (seg.startsWith(':') ? ap[i] : seg)).join('/');
}

/**
 * @param pathname     Le path actuel (ex: location.pathname)
 * @param overrideLast Si défini, remplace le label du dernier item
 *                     (typiquement le titre de l'item édité/consulté).
 */
export function buildAdminBreadcrumb(pathname, overrideLast) {
  const matched = findNodeKey(pathname);
  if (!matched) return [{ label: 'Admin' }];

  const chain = [];
  let cursor = matched;
  while (cursor) {
    const node = BREADCRUMB_NODES[cursor];
    chain.unshift({
      label: node.label,
      href: reifyHref(cursor, pathname),
    });
    cursor = node.parent;
  }
  // Le dernier item n'est pas un lien
  chain[chain.length - 1] = { ...chain[chain.length - 1], href: undefined };

  if (overrideLast && chain.length > 0) {
    chain[chain.length - 1].label = overrideLast;
  }

  return chain;
}
